"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalBar = void 0;
var React = __importStar(require("react"));
var GKTooltip_1 = require("../../GKTooltip");
var GKBarChartContext_1 = require("./../GKBarChartContext");
var HorizontalBar = function (_a) {
    var d = _a.d, range = _a.range, xLabelWidth = _a.xLabelWidth, qa = _a.qa;
    var width = (Math.abs(d.value) * 100) / range + "%";
    var normedId = d.xLabel.replace(/ |\#/g, "");
    var barRef = React.useRef(null);
    var yLabelRef = React.useRef(null);
    var chart = React.useContext(GKBarChartContext_1.BarChartContext);
    React.useLayoutEffect(function () {
        var _a, _b;
        var rect = (_a = yLabelRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        (_b = chart.updateYLabelSize) === null || _b === void 0 ? void 0 : _b.call(chart, rect === null || rect === void 0 ? void 0 : rect.width);
    }, [chart]);
    return (React.createElement("div", { key: normedId, className: "my-2 w-100", "data-qa": qa, id: normedId },
        React.createElement("div", { className: "pl-2 mb-2 text-truncate overflow-hidden", "data-qa": qa + "--xlabel", style: { width: xLabelWidth } }, d.xLabel),
        React.createElement("div", { className: "position-relative d-flex", style: {
                right: d.value < 0 ? "calc(" + width + " + 1px)" : "0px",
            } },
            React.createElement("div", { ref: barRef, "data-qa": qa + "--bar", style: {
                    height: "20px",
                    backgroundColor: d.color,
                    width: width,
                }, 
                /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
                tabIndex: 0 },
                React.createElement("b", { className: "pl-2 font-weight-bold text-nowrap position-relative", "data-qa": qa + "--ylabel", style: { left: "100%" }, ref: yLabelRef }, d.yLabel))),
        d.tooltip && (React.createElement(GKTooltip_1.GKTooltip, { target: barRef, "data-qa": qa + "--tooltip" }, d.tooltip))));
};
exports.HorizontalBar = HorizontalBar;
